<template>
    <v-layout row wrap align-center>
        <div class="quantity">
            <input 
                class="v-input custom-placeholer-color"
                type="number" 
                :placeholder="isOrganicsOrder&&!isPrintPage ? 'Quantity' : '' "
                :value="inputQuantity" 
                @input="updateInputQuantity" 
                :readonly="!editable" 
                v-on:keypress="$emit('InputQuantityKeypress', $event)"  
                v-on:paste="$emit('InputQuantityPaste', $event)"
            />
        </div>
         <div class="quantity" v-if='isOrganicsOrder'>
            <input 
                class="v-input custom-placeholer-color"
                :placeholder="isPrintPage ? '' : 'Stock'"
                type="number" 
                :value="inputStock" 
                @input="updateInputStock" 
                :readonly="!editable" 
                v-on:keypress="$emit('InputQuantityKeypress', $event)"  
                v-on:paste="$emit('InputQuantityPaste', $event)"
            />
        </div>
        <v-flex> 
            <span>{{ product.Name }}</span>
            <v-icon v-if="showCommentField" middle :color="comments ? 'green' : 'grey'" @click="addComment">comment</v-icon>
        </v-flex>
        <v-dialog v-model="commentDialog" max-width="400">
            <v-card class="no-padding">
                <v-container>
                <v-layout>
                    <v-flex>
                        <v-textarea
                            :ref="commentInputRef"
                            label="Comment"
                            :auto-grow="true"
                            v-model="temporaryComments"
                        ></v-textarea>
                    </v-flex>
                </v-layout>
                  </v-container>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" flat="flat" @click="closeAddComment">Cancel</v-btn>
                <v-btn color="green" flat="flat" @click="updateComment">Add</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
export default {
    components: {

    },
    props: [
        'orderID',
        'product',
        'editable',
        'showCommentField',
        'initialQuantity',
        'initialStock',
        'initialComments',
        'isOrganicsOrder',
        'isPrintPage',
    ],
    data() {
        return {
            temporaryComments: null,
            commentDialog: false,
            inputQuantity: this.initialQuantity,
            inputStock: this.initialStock,
            comments: this.initialComments
        };
    },
    computed: {
        commentInputRef() {
            return "comment_" + this.product.ID;
        }
    },
    methods: {
        clearInput() {
            this.inputQuantity = null;
            this.inputStock = null;
        },
        updateInputQuantity(value){
            this.inputQuantity = value.target.value;

            this.$store.dispatch("placeOrderStore/updateProductQuantity", {
                productID: this.product.ID,
                quantity: value.target.value
            });
        },
        updateInputStock(value){
            this.inputStock = value.target.value;

            this.$store.dispatch("placeOrderStore/updateProductStock", {
                productID: this.product.ID,
                stock: value.target.value
            });
        },
        updateComments(value) {
            this.comments = value;

            this.$store.dispatch("placeOrderStore/updateOrderProductsComments", {
                productID: this.product.ID,
                comments: value,
                orderID: this.orderID
            });
        },
        addComment() {
            this.temporaryComments = this.comments + "";
            this.commentDialog = true;
        },
        closeAddComment() {
            this.commentDialog = false;
            this.temporaryComments = null;
        },
        updateComment() {
            this.updateComments(this.temporaryComments + "");
            this.closeAddComment();
        }
    },
    created(){

    },
    watch: {
        commentDialog: function() {
            if (this.commentDialog) {
                this.$nextTick(this.$refs[this.commentInputRef].focus);
            }
        }
    }
};
</script>

<style>
.quantity{
    padding: 2px 0px;
    width: 48px;
    margin-right: 16px;
}

.quantity input {
    min-height: 32px;
    height: 100%;
    width: 63px;
    border: 1px solid #000;
    text-align: center;
}

.quantity input[type="number"] {
    -moz-appearance: textfield;
}

.quantity input[type="number"]::-webkit-outer-spin-button, .quantity input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0px;
}

::placeholder {
  color: lightgray !important;
  opacity: 1;
}

</style>
